import React from "react";
import { Link } from "react-router-dom";
import { useState, useEffect } from "react";
import Select from "react-select";
import { ThreeDots } from "react-loader-spinner";
import Breadcrumbs from "../../components/Breadcrumbs";
import {
  API_ADD_EMAIL_DELETION_REQUEST,
  API_GET_EMAIL_DELETION_USER_DETAILS_BY_EMPLOYEE_ID,
  API_GET_EMAILDELETION_USERS_LIST,
} from "../../config/Endpoints";
import axios from "axios";
import { toast } from "react-toastify";
import Cookies from "js-cookie";
import { TailSpin } from "react-loader-spinner";
import { useNavigate } from "react-router-dom";

const AddEmailDeletionRequest = ({ title, description }) => {
  const userData = JSON.parse(localStorage.getItem("userData"));
  const accessToken = Cookies.get("accessToken");
  const [employeeList, setEmployeeList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [isLoadingDelete, setIsLoadingDelete] = useState(false);
  const [selectedEmployee, setSelectedEmployee] = useState(null);
  const [reason, setReason] = useState("");
  const [employeeDetails, setEmployeeDetails] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const navigate = useNavigate();

  const reasonOptions = [
    { value: "Delete & Create Alias", label: "Delete & Create Alias" },
    {
      value: "Suspend",
      label: "Suspend",
    },
    {
      value: "Change Password",
      label: "Change Password",
    },
    {
      value: "Delete",
      label: "Delete",
    },
  ];

  useEffect(() => {
    document.body.style.overflow = showModal ? "hidden" : "auto";
  }, [showModal]);

  const handleDelete = async () => {
    try {
      setIsLoadingDelete(true);

      const payload = {
        employeeId: selectedEmployee?.value,
        createdBy: userData?.id,
        reqStatus: 0,
        reqReason: reason,
      };

      const response = await axios.post(
        API_ADD_EMAIL_DELETION_REQUEST,
        payload,
        {
          headers: {
            Authorization: `Bearer ${accessToken}`,
            "Content-Type": "application/json",
          },
        }
      );

      if (response?.data?.message) {
        toast.success(
          response.data.message || "Request submitted successfully."
        );
        navigate("/dashboard/email-deletion");
      }

      setSelectedEmployee(null);
      setReason("");
      setEmployeeDetails(null);
      setShowModal(false);
    } catch (error) {
      toast.error(
        error?.response?.data?.message || "Failed to submit request."
      );
    } finally {
      setIsLoadingDelete(false);
    }
  };

  useEffect(() => {
    const fetchEmployeeList = async () => {
      setLoading(true);
      try {
        const response = await axios.get(API_GET_EMAILDELETION_USERS_LIST, {
          headers: { Authorization: `Bearer ${accessToken}` },
        });

        const employees = response.data.data.map((u) => ({
          value: u.id,
          label: u.fullName,
        }));

        setEmployeeList(employees);
      } catch (error) {
        toast.error(
          error?.response?.data?.message || "Failed to fetch employee list"
        );
        setEmployeeList([]);
      } finally {
        setLoading(false);
      }
    };

    fetchEmployeeList();
  }, []);

  useEffect(() => {
    const fetchEmployeeDetails = async () => {
      if (!selectedEmployee) {
        setEmployeeDetails(null);
        return;
      }

      try {
        const response = await axios.get(
          `${API_GET_EMAIL_DELETION_USER_DETAILS_BY_EMPLOYEE_ID}/${selectedEmployee.value}`,
          {
            headers: { Authorization: `Bearer ${accessToken}` },
          }
        );

        setEmployeeDetails(response?.data?.data);
      } catch (error) {
        toast.error("Failed to fetch employee details");
        setEmployeeDetails(null);
      }
    };

    fetchEmployeeDetails();
  }, [selectedEmployee]);

  return (
    <div className="wrapper-body">
      {loading && (
        <div className="overlay">
          <div className="mt-5">
            <TailSpin
              height="100"
              width="100"
              radius="1"
              color="blue"
              ariaLabel="tail-spin-loading"
              wrapperStyle={{}}
              wrapperClassName=""
              visible={true}
            />
          </div>
        </div>
      )}
      <div className="page-heading">
        <Breadcrumbs
          items={[
            { label: "Email Deletion", path: "/dashboard/email-deletion" },
            { label: "Add Email Deletion Request" },
          ]}
        />
      </div>
      <form
        onSubmit={(e) => {
          e.preventDefault();
          if (!selectedEmployee || !reason) return; // ensure required
          setShowModal(true); // open modal only if valid
        }}
      >
        <div className="card px-4">
          {/* Employee Select */}
          <div className="row justify-content-center">
            <div className="col-md-5 px-4">
              <Select
                className="custom-select"
                classNamePrefix="react-select"
                options={employeeList}
                value={selectedEmployee}
                onChange={(employee) => {
                  setSelectedEmployee(employee);
                  setReason("");
                }}
                placeholder="Select Employee Name"
                isDisabled={loading}
                isClearable
                required
              />
            </div>
          </div>
        </div>

        {/* Centered Content */}
        {selectedEmployee && employeeDetails && (
          <div className="card p-4">
            <div className="row justify-content-center p-4">
              <div className="col-md-12">
                {/* Row 1 */}
                <div className="row mb-3">
                  <div className="col-md-3 text-black-50">Employee Name</div>
                  <div className="col-md-3 mb-2">
                    {employeeDetails?.fullName || "-"}
                  </div>
                  <div className="col-md-2 text-black-50">Status</div>
                  <div className="col-md-4 mb-2">
                    {employeeDetails?.status || "-"}
                  </div>
                </div>

                {/* Row 2 */}
                <div className="row mb-3">
                  <div className="col-md-3 text-black-50">
                    Project Eligibility
                  </div>
                  <div className="col-md-3 mb-2">
                    {employeeDetails?.isTech ? "Yes" : "No"}
                  </div>
                  <div className="col-md-2 text-black-50">Email</div>
                  <div className="col-md-4 mb-2 text-break">
                    {employeeDetails?.email || "-"}
                  </div>
                </div>

                {/* Row 3 */}
                <div className="row mb-3">
                  <div className="col-md-3 text-black-50">Employee Type</div>
                  <div className="col-md-3 mb-2">
                    {employeeDetails?.employeeType || "-"}
                  </div>
                  <div className="col-md-2 text-black-50">
                    <label class="has-asterisk">Action Required</label>
                  </div>
                  <div className="col-md-4 mb-2">
                    <Select
                      className="custom-select"
                      classNamePrefix="react-select"
                      options={reasonOptions}
                      value={
                        reasonOptions.find((r) => r.value === reason) || null
                      }
                      onChange={(selectedOption) =>
                        setReason(selectedOption ? selectedOption.value : "")
                      }
                      placeholder="Select Action"
                      isDisabled={loading}
                      isClearable
                      required
                    />
                  </div>
                </div>

                {/* Buttons Row */}
                <div className="row justify-content-center mt-3">
                  <div className="col-md-3 d-flex justify-content-start gap-3">
                    <button type="submit" className=" theme-button w-45 ">
                      Submit{" "}
                    </button>
                    <Link
                      to="/dashboard/email-deletion"
                      className="brand-color"
                    >
                      <button
                        type="button"
                        className="theme-button px-3 bg-grey"
                      >
                        Cancel
                      </button>
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      </form>

      {/* Modal & Backdrop */}
      {showModal && (
        <>
          <div
            className="modal-backdrop fade show"
            style={{
              position: "fixed",
              top: 0,
              left: 0,
              width: "100%",
              height: "100%",
              backgroundColor: "rgba(0,0,0,0.5)",
              zIndex: 1040,
            }}
          />
          <div
            className="modal fade show d-block"
            tabIndex="-1"
            aria-hidden="true"
            style={{ zIndex: 1050 }}
          >
            <div className="modal-dialog modal-dialog-centered modal-md">
              <div className="modal-content">
                <div className="modal-body">
                  <h5 className="text-center">
                    Are you sure you want to proceed with this action?
                  </h5>
                </div>
                <div className="justify-content-center modal-footer">
                  <button
                    type="button"
                    className={
                      isLoadingDelete ? "theme-button disabled" : "theme-button"
                    }
                    onClick={handleDelete}
                  >
                    {isLoadingDelete ? (
                      <ThreeDots
                        height="20"
                        width="53"
                        radius="9"
                        color="white"
                        ariaLabel="three-dots-loading"
                        visible={true}
                      />
                    ) : (
                      "Yes"
                    )}
                  </button>
                  <button
                    type="button"
                    className="theme-button bg-grey mx-3 w-35"
                    onClick={() => setShowModal(false)}
                  >
                    No
                  </button>
                </div>
              </div>
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default AddEmailDeletionRequest;
